<template>
    <div>
        <div class="box">
            <div class="box-content">
                <h3 class="txt-primary mt-0">Lead Details:</h3>
                <div class="leads-list-item">
                    <div class="content">
                        <div class="top">
                            <div class="system-type p-3">
                                <div>
                                    <strong>System:</strong>
                                    <span v-if="lead.epwin_system_type !== null"> {{ lead.epwin_system_type.label }} </span>
                                    <span v-else>N/A</span>
                                </div>
                            </div>
                            <template v-if="logged_in_user.isStaff">
                                <div class="type p-3">
                                    <div>
                                        <strong>Type:</strong> <span>{{ lead.type }}</span>
                                    </div>
                                </div>
                                <div class="source p-3">
                                    <div>
                                        <strong>Source:</strong> <span>{{ lead.source }}</span>
                                    </div>
                                </div>
                            </template>
                            <div class="status p-3" v-if="!logged_in_user.isStaff">
                                <strong>Status:</strong>
                                <template v-for="(company, index) in lead.companies" v-if="company.id === logged_in_user.company_id">
                                    <select class="form-control _sm" style="max-width: 300px;" v-model="company.pivot.lead_status_id" @change="updateStatus($event, company.id)" v-if="[3,4,5,6].includes(company.pivot.lead_status_id)">
                                        <option v-for="status in statuses"
                                                :value="status.id"
                                                :disabled="
                                                company.pivot.lead_status_id === 1 ||
                                                status.id === 1 ||
                                                company.pivot.lead_status_id < 3 && status.id === 2"
                                                v-show="status.id > 2 && status.id != 7">
                                            {{ status.label }}
                                        </option>
                                    </select>
                                    <div v-if="company.id === logged_in_user.company_id && ![3,4,5,6].includes(company.pivot.lead_status_id)">
                                      {{ status_label(company.pivot.lead_status_id) }}
                                    </div>
                                    <div class="txt-sm mt-1" v-if="company.pivot.status_updated_by_name !== null">
                                      Updated By: {{ company.pivot.status_updated_by_name }} - {{ company.pivot.status_updated_at_formatted }}
                                    </div>
                                </template>
                            </div>
                        </div>
                        <div class="contact-details">
                            <div class="p-3">
                                <strong>Contact Details:</strong>
                            </div>
                            <div class="p-3">
                                <i class="fal fa-user txt-primary pr-2"></i>
                                <span v-if="lead.name !== null"> {{ lead.name }} </span>
                                <span v-else>--</span>
                            </div>
                            <div class="p-3">
                                <i class="fal fa-envelope txt-primary pr-2"></i>
                                <span v-if="lead.email !== null"> {{ lead.email }} </span>
                                <span v-else>--</span>
                            </div>
                            <div class="p-3">
                                <i class="fal fa-phone txt-primary pr-2"></i>
                                <span v-if="lead.phone !== null"> {{ lead.phone }} </span>
                                <span v-else>--</span>
                            </div>
                        </div>
                        <div class="address p-3">
                            <strong>Address: </strong>
                            <span v-if="lead.address !== null"> {{ lead.address }}, </span>
                            <span v-if="lead.postcode !== null"> {{ lead.postcode }} </span>
                        </div>
                        <div class="bottom">
                            <div class="details p-3">
                                <span>{{ lead.details }}</span>
                            </div>
                        </div>
                    </div>
                  <div class="lead-attachments">
                    <a class="attachment cursor-pointer" v-for="(attachment, index) in lead.lead_attachments" target="_blank" @click.stop-prevent="downloadAttachment(attachment.id)"
                       :data-filename="attachment.file_name">
                      <div class="icon">
                        <i class="fal fa-paperclip"></i>
                      </div>
                      <div class="filename">
                        {{ attachment.file_name }}
                      </div>
                    </a>
                  </div>
                  <template v-for="(company, index) in lead.companies" v-if="!logged_in_user.isStaff && company.id === logged_in_user.company.id">
                    <div class="flex justify-end" v-if="company.pivot.lead_status_id === 2">
                      <div>
                        <a class="btn-danger" @click="rejectLead()">
                          Reject Lead
                        </a>
                      </div>
                      <div>
                        <a class="btn-primary" @click="acceptLead()">
                          Accept Lead
                        </a>
                      </div>
                    </div>
                  </template>
                </div>
            </div>
        </div>
        <div class="box mt-3 mt-6-sm" v-if="logged_in_user.isStaff">
            <div class="box-content">
                <div class="flex justify-between">
                    <div>
                        <h3 class="txt-primary mt-0">Assigned to:</h3>
                    </div>
                    <div class="align-right">
                        <a :href="`/leads/assign/${lead.id}`">
                            <i class="fal fa-pencil"></i>
                        </a>
                    </div>
                </div>
                <table class="table_leads-assigned-to-list">
                    <thead>
                    <tr>
                        <th>Company Name</th>
                        <th>Status</th>
                        <th></th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(company, index) in lead.companies">
                        <td>{{ company.name }}</td>
                        <td class="td_status">
                            <select class="form-control _sm" v-model="company.pivot.lead_status_id" @change="updateStatus($event, company.id)">
                                <option v-for="status in statuses"
                                :value="status.id"
                                :disabled="
                                company.pivot.lead_status_id === 1 ||
                                status.id === 1 ||
                                company.pivot.lead_status_id < 3 && status.id === 2"
                                v-show="!logged_in_user.isStaff && status.id > 1 || logged_in_user.isStaff">
                                {{ status.label }}
                                </option>
                            </select>
                            <div class="txt-sm mt-1" v-if="company.pivot.status_updated_by_name !== null">
                              Updated By: {{ company.pivot.status_updated_by_name }} - {{ company.pivot.status_updated_at_formatted }}
                            </div>
                        </td>
                        <td class="td_view-user">
                            <a :href='"/company/"+company.id' class="txt-primary" target="_blank">
                                <i class="fa fa-eye"></i>
                            </a>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
  export default {
    props: [
      'logged_in_user',
      'prop_lead',
      'statuses',
    ],
    data() {
      return {
        saving: false,
        lead: this.prop_lead,
      }
    },
    methods: {
      updateStatus(event, company_id) {
        const status = event.target.value;
        axios.post('/leads/updateStatus',{
          lead_id: this.lead.id,
          status_id: status,
          company_id: company_id,
        }).then(() => {

            Swal.fire({
                title: 'Status Updated',
                icon: 'success',
                html: '',
            });

          if(status == 7) {
            window.location.href = '/leads';
          }

        });
      },
      rejectLead() {
        Swal.fire({
          title: 'Are you sure you want to reject this lead?',
          text: 'If you select Reject you will no longer be able to view this lead.',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Reject',
        }).then((result) => {
          if (result.isConfirmed) {
            this.deleting = true;
            axios.post('/leads/updateStatus', {
              lead_id: this.lead.id,
              status_id: 7,
              company_id: this.logged_in_user.company_id,
            }).then((response) => {
              window.location.href = '/leads';
            });
          }
        });
      },
      acceptLead() {
        axios.post('/leads/updateStatus',{
          lead_id: this.lead.id,
          status_id: 6,
          company_id: this.logged_in_user.company_id,
        }).then((response) => {
          Swal.fire({
            title: 'Lead Accepted',
            icon: 'success',
            text: 'Please update the status as you progress with this lead.',
          }).then(function () {
            window.location.reload();
          });
        });
      },
      status_label(id) {
        return this.statuses.filter((status) => status.id === id)[0].label;
      },
      downloadAttachment(attachment_id) {
        axios.post( '/leads/download-attachment', {
          attachment_id: attachment_id,
        }).then((response) => {
          window.location.href = response.data;
        });
      },
    },
  };
</script>
